import { JsonObject } from 'json2typescript';
import { CodeTextDiscriminatorModel } from 'humanresources-common-shared';

@JsonObject('KovanHrPerWorkAreaModel')
export class PerWorkAreaModel extends CodeTextDiscriminatorModel {}
